/**
 * The type of redux action which stores a specific JSON Web Token (JWT) into
 * the redux store.
 *
 * {
 *     type: SET_USERDATA,
 *     jwt: string
 * }
 */
export const SET_SIGNLANG_ENABLED = 'SET_SIGNLANG_ENABLED';
export const SET_SIGNLANG_DISPLAY_STRING = 'SET_SIGNLANG_DISPLAY_STRING';
export const SET_SIGNLANG_WINDOWSIZE_VALUE = 'SET_SIGNLANG_WINDOWSIZE_VALUE';
